module.exports = __webpack_public_path__ + "img/localadventures-payments-usd.83999d5.svg";